import { Box } from '@mui/material'

/**
 * Renders `text` with every case-insensitive occurrence of `query` wrapped in a highlight mark.
 * Safe to drop into a Typography/heading — returns the plain string when there's no query/match.
 */
export function HighlightedText({ text, query }) {
  const value = text == null ? '' : String(text)
  const trimmedQuery = (query || '').trim()
  if (!trimmedQuery) return value

  const lowerValue = value.toLowerCase()
  const lowerQuery = trimmedQuery.toLowerCase()
  if (!lowerValue.includes(lowerQuery)) return value

  const segments = []
  let cursor = 0
  let matchIndex = lowerValue.indexOf(lowerQuery)
  while (matchIndex !== -1) {
    if (matchIndex > cursor) {
      segments.push({ text: value.slice(cursor, matchIndex), match: false })
    }
    segments.push({ text: value.slice(matchIndex, matchIndex + lowerQuery.length), match: true })
    cursor = matchIndex + lowerQuery.length
    matchIndex = lowerValue.indexOf(lowerQuery, cursor)
  }
  if (cursor < value.length) {
    segments.push({ text: value.slice(cursor), match: false })
  }

  return (
    <>
      {segments.map((segment, index) =>
        segment.match ? (
          <Box
            key={index}
            component="mark"
            sx={{
              backgroundColor: 'rgba(250, 204, 21, 0.45)',
              color: 'inherit',
              borderRadius: '3px',
              px: '1px',
            }}
          >
            {segment.text}
          </Box>
        ) : (
          <Box key={index} component="span">
            {segment.text}
          </Box>
        ),
      )}
    </>
  )
}
